import type { NAuth } from '@app/types/Auth';

export namespace NLogs {
  export type Main = (args: {
    userId: NAuth.UserPrint['userId'];
    database: NAuth.UserPrint['database'];
  }) => Promise<Result | unknown>;

  export type Result = {
    HeaderUserId: NAuth.UserPrint['userId'] | null;
    HeaderDatabase: NAuth.UserPrint['database'] | null;
    HeaderIsMobile: string | null;
    HeaderOS: HeaderOS | null;
    HeaderIP: string | null;
  };

  export type HeaderOS = 'windows' | 'linux' | 'android' | 'ios' | 'other';
}
